import { OnInit } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
var AutosuggestPanelComponent = /** @class */ (function () {
    function AutosuggestPanelComponent() {
    }
    Object.defineProperty(AutosuggestPanelComponent.prototype, "hostClasses", {
        get: function () {
            return resolveThemeCssClass(this.data);
        },
        enumerable: true,
        configurable: true
    });
    AutosuggestPanelComponent.prototype.ngOnInit = function () {
        this.data = this.tempMap(this.data);
        if (!this.data) {
            return;
        }
    };
    AutosuggestPanelComponent.prototype.tempMap = function (data) {
        var res = {};
        res['tip'] = {
            value: 'Search...'
        };
        return res;
    };
    return AutosuggestPanelComponent;
}());
export { AutosuggestPanelComponent };
